/**
 * @generated SignedSource<<a0090f7c69416f5ef92ac1cd278ba208>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBodyViewerSubIssues$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddSubIssueButtonGroup" | "useHasSubIssues">;
  readonly " $fragmentType": "IssueBodyViewerSubIssues";
};
export type IssueBodyViewerSubIssues$key = {
  readonly " $data"?: IssueBodyViewerSubIssues$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyViewerSubIssues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyViewerSubIssues",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useHasSubIssues"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddSubIssueButtonGroup"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "e9e98381f0fbbaad2da9213db400455f";

export default node;
